module.exports = __webpack_public_path__ + "img/icon_comunity_white.2eb0bc60.svg";